<template>
  <div>
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('add')}} {{ $tc('module', 2)}} {{ $tc('feature') }}</div>
      <router-link class="btn-blue" to="module-features">{{ $tc('module' , 2)}} {{ $tc('list')}}</router-link>
    </div>
    <div class="edit-movie-container">
      <form class="row">
        <div class="col-md-6 mb-4">
          <div>
            <b-dropdown text="Select Module" variant="dropdown-curve" class="w-75">
              <b-dropdown-item href="#">Module 1</b-dropdown-item>
              <b-dropdown-item href="#">Module 2</b-dropdown-item>
              <b-dropdown-item href="#">Module 3</b-dropdown-item>
              <b-dropdown-item href="#">Module 4</b-dropdown-item>
            </b-dropdown>
            <p class="error_message">This selector cannot be blank !</p>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="row"></div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="row">
            <div class="col-md-9 col-xl-10">
              <div>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox" class="custom-control-input" id="customControlInline1">
                  <label class="custom-control-label" for="customControlInline1">{{ $tc('feature', 1) }} 1</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="row">
            <div class="col-md-9 col-xl-10">
              <div>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox" class="custom-control-input" id="customControlInline2">
                  <label class="custom-control-label" for="customControlInline2">{{ $tc('feature', 1) }} 2</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="row">
            <div class="col-md-9 col-xl-10">
              <div>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox" class="custom-control-input" id="customControlInline3">
                  <label class="custom-control-label" for="customControlInline3">{{ $tc('feature', 1) }} 3</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="row">
            <div class="col-md-9 col-xl-10">
              <div>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox" class="custom-control-input" id="customControlInline4">
                  <label class="custom-control-label" for="customControlInline4">{{ $tc('feature', 1) }} 4</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="row">
            <div class="col-md-9 col-xl-10">
              <div>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox" class="custom-control-input" id="customControlInline5">
                  <label class="custom-control-label" for="customControlInline5">{{ $tc('feature', 1) }} 5</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="row">
            <div class="col-md-9 col-xl-10">
              <div>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox" class="custom-control-input" id="customControlInline6">
                  <label class="custom-control-label" for="customControlInline6">{{ $tc('feature', 1) }} 6</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button class="btn-blue">{{ $t('save')}} & {{ $t('add')}} {{ $t('more')}}</button>
          <button class="btn-blue">{{ $t('save')}}</button>
          <button class="btn-black">{{ $t('reset')}}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="module-features"
          >{{ $t('cancel')}}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/AddContainer/addModuleFeatures.vue